<div class="provider-filters-content" *ngIf="show">
    <app-provider-filters-body 
        [filterModel]="filterModel"
        [publicProfileTypes]="publicProfileTypes"
        [providerSearchMessage]="providerSearchMessage">
    </app-provider-filters-body>
</div>